import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {
    this.links = [];
  }

  connect() {
    this.links = this.element.getElementsByTagName("a");
    for (const link of this.links) {
      link.addEventListener("click", () => this.navigate(link));
    }

    window.addEventListener("popstate", this.popStateListener);
  }

  disconnect() {
    window.removeEventListener("popstate", this.popStateListener);
    for (const link of this.links) {
      link.removeEventListener("click", () => this.navigate(link));
    }
  }

  navigate(link) {
    const href = link.getAttribute("href");
    if (href != null) {
      history.pushState({ turbo_frame_history: true }, "", href);
      window.scrollTo(0, 0);
    }
  }

  popStateListener(event) {
    if (event.state?.turbo_frame_history) {
      Turbo.visit(window.location.href, { action: "replace" });
    }
  }
}
